import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-subpage-encuentros-el-conocer-y-el-sentir',
  templateUrl: './subpage-encuentros-el-conocer-y-el-sentir.component.html',
  styleUrls: ['./subpage-encuentros-el-conocer-y-el-sentir.component.scss']
})
export class SubpageEncuentrosElConocerYElSentirComponent implements OnInit {

  constructor() { 
    window.scroll(0,0);
  }

  ngOnInit() {
  }

}
